import { useMutation } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

import { axios } from "../axios"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { API_SBP_COMBINED_PAYMENTS_MBANK_URL } from "../constants"

interface CreatePaymentRequest {
  externalCombinedPaymentId: string
  bankId: string
  amount: number
  token: string
  exchangeRate: string | null
}

interface CreatePaymentResponse {
  combinedPaymentId: string
}

interface CreatePaymentParams {
  bankId: string,
  amount: number | null,
  exchangeRate: string | undefined,
}

const createPayment = async ({ token, ...data }: CreatePaymentRequest) => {
  const response = await axios(`${API_SBP_COMBINED_PAYMENTS_MBANK_URL}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data,
  })

  if (checkIsFailure(response.status)) {
    throw new Error(
      `Ошибка при создании платежа: ${response.status} - ${response.statusText}`,
    )
  }

  return response.data
}

export const useCreatePayment = () => {
  const navigate = useNavigate()
  const token = useSelector((state: RootState) => state.auth.token)
  // const paymentId = useSelector((state: RootState) => state.auth.paymentId)

  return useMutation<CreatePaymentResponse, Error, CreatePaymentParams>({
    mutationFn: ({ bankId, amount, exchangeRate } : CreatePaymentParams) =>
      createPayment({
        externalCombinedPaymentId: crypto.randomUUID(),
        bankId,
        amount: amount ?? 0,
        token: token || "",
        exchangeRate: exchangeRate ? Number(exchangeRate).toFixed(2) : null,
      }),
    onError: () => {
      navigate("/error")
    },
  })
}
